import type { ControlProps } from "../../../../components/formControls/BaseControl";

export interface CarbonButtonProps extends ControlProps {}

export const CarbonButton = () => {
  return null;
};
